import { useCallback, useEffect, useState } from "react";
import { ModalGeneric } from "../../../utils/ModalGeneric";
import { ServiceResumoDesk } from "@/services/serviceResumoDesk";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import notify from "@/services/notify.tsx";
import Select from "react-select";
import debounce from "lodash.debounce";
import ConfigDesks from "@/services/configDesks";
import { IconEdit } from "@/assets/images/Icons";
import { confirmAlert } from "react-confirm-alert";
import { IconDelete } from "@/pages/UserGoOn/Desks/ResumoDesk/Icons";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export function Subtarefas({ data }: any) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [subTasks, setSubTasks] = useState([]);

  const { register, handleSubmit, reset, setValue, watch } = useForm();

  const [users, setUsers] = useState<any>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [expandedTaskId, setExpandedTaskId] = useState<number | null>(null);

  const toggleTaskDescription = (id: number) => {
    setExpandedTaskId(expandedTaskId === id ? null : id);
  };

  const onSubmit = async (payload: any) => {
    const toastId = notify.loading("Salvando subtarefa...");
    try {
      setIsSubmiting(true);

      let res;
      payload.id_tarefa = data.id;
      payload.id_responsavel = payload.id_responsavel.value;

      if (isEdit) {
        res = await ServiceResumoDesk.subTaskedit(payload, payload.id);
      } else {
        payload.status = 1;
        res = await ServiceResumoDesk.subTaskadd(payload);
      }
      if (res.status === 200) {
        notify.update(
          toastId,
          "success",
          isEdit ? "Subtarefa atualizada!" : "Subtarefa criada!",
        );
        reset();
        setIsOpen(false);
        getSubTasks();
        queryClient.invalidateQueries({ queryKey: ["subTarefas"] });
      }
    } catch (error: any) {
      notify.update(
        toastId,
        "error",
        error?.response?.data?.msg ||
          error?.response?.data?.error ||
          "Erro ao salvar subtarefa",
      );
    } finally {
      setIsSubmiting(false);
    }
  };

  async function getSubTasks() {
    try {
      const res = await ServiceResumoDesk.subTask(data.id);

      if (res.status == 200) {
        setSubTasks(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  }

  useEffect(() => {
    getSubTasks();
  }, [data]);

  const loadUsers = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingUsers(true);
        const res = await ConfigDesks.getContatosBusca(1, 10, inputValue);
        if (res.status === 200) {
          setUsers(res.data.data);
        }
        setLoadingUsers(false);
      } else {
        setUsers([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeUsers = (inputValue: any) => {
    loadUsers(inputValue);
    return inputValue;
  };

  function formatUserData(users: any) {
    return users.map((user: any) => ({
      label: `${(user.name || "").trim()} ${(user.last_name || "").trim()}`,
      value: user.id,
      image: user.filePath,
    }));
  }

  async function editTask(task: any) {
    setIsOpen(true);

    setValue("id_responsavel", {
      value: task.id_responsavel,
      label: task.responsavel,
    });
    setValue("id_tarefa", task.id_tarefa);
    setValue("id", task.id);

    setValue("title", task.title);
    setValue("description", task.description);
    setValue("status", task.status);
    setIsEdit(true);
  }

  async function checkedTask(id: any, status: any) {
    try {
      const payload = { status };
      const res = await ServiceResumoDesk.subTaskedit(payload, id);
      if (res.status === 200) {
        getSubTasks();
      }
    } catch (error) {
      console.error("Erro:", error);
      toast.error(t("tasks.messages.editError"));
    }
  }

  async function deleteDesk(id: any) {
    confirmAlert({
      title: t("common:confirmation"),
      message: t("tasks.subtasks.delete_confirm"),
      buttons: [
        {
          label: t("common:yes"),
          onClick: async () => {
            try {
              const res = await ServiceResumoDesk.subTaskdel(id);
              if (res.status === 200) {
                getSubTasks();
              }
            } catch (error) {
              console.error("Erro:", error);
              toast.error("Erro ao Deletar");
            }
          },
        },
        {
          label: t("common:cancel"),
          onClick: () => {},
        },
      ],
    });
  }
  return (
    <div className="pr-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <i className="bi bi-clipboard2-check-fill text-[#797979] text-base"></i>
          <span>{t("tasks.subtasks.title")}:</span>
        </div>
        <button type="button" onClick={() => setIsOpen(true)}>
          <i className="bi bi-plus-square-fill text-[#797979] text-sm"></i>
        </button>
      </div>

      <div className="space-y-1 mt-2">
        {subTasks.map((e: any) => (
          <div
            className="border border-cinza-300 rounded-xl px-4 py-1 ml-5"
            key={e.id}
          >
            <div className="flex items-center justify-between">
              <button className="flex gap-2 items-center">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 11 11"
                  fill={e.status == 1 ? "none" : "#153DCE"}
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => checkedTask(e.id, e.status == 1 ? 2 : 1)}
                >
                  <circle
                    cx="5.5"
                    cy="5.5"
                    r="5"
                    stroke={e.status == 1 ? "black" : "#153DCE"}
                  />
                </svg>

                <span
                  onClick={() => toggleTaskDescription(e.id)}
                  className={e.status == 1 ? "" : "line-through"}
                >
                  {e.title}
                </span>
              </button>
              <div className="flex items-center gap-2">
                <span>{e.responsavel}</span>
                <div className="flex items-center justify-end gap-2">
                  <button type="button" onClick={() => editTask(e)}>
                    <IconEdit />
                  </button>
                  <button type="button" onClick={() => deleteDesk(e.id)}>
                    <IconDelete />
                  </button>
                </div>
              </div>
            </div>
            {expandedTaskId === e.id && (
              <div className="text-xs text-gray-600 pl-5">{e.description}</div>
            )}
          </div>
        ))}
      </div>

      {isOpen && (
        <ModalGeneric
          onClose={() => {
            setIsOpen(false);
            setIsEdit(false);
            reset();
          }}
          size="max-w-[70%] w-full px-4 py-4"
        >
          <form className="space-y-2" onSubmit={handleSubmit(onSubmit)}>
            <h2 className="text-base font-medium">
              {t("tasks.subtasks.modal.title")}
            </h2>
            <input
              type="text"
              placeholder={t("tasks.subtasks.fields.title.placeholder")}
              required
              className="bg-gray-200 px-2 py-1 w-full rounded-lg"
              {...register("title")}
            />
            <input
              type="text"
              placeholder={t("tasks.subtasks.fields.description.placeholder")}
              required
              className="bg-gray-200 px-2 py-1 w-full rounded-lg"
              {...register("description")}
            />
            <Select
              placeholder={t("tasks.subtasks.fields.responsible.placeholder")}
              required
              {...register("id_responsavel")}
              onChange={(value: any) => setValue("id_responsavel", value)}
              onInputChange={handleInputChangeUsers}
              isLoading={loadingUsers}
              value={watch("id_responsavel")}
              options={formatUserData(users)}
              noOptionsMessage={() => t("common:type_to_search")}
              formatOptionLabel={(user: any) => (
                <div className="flex gap-2 items-start">
                  <img
                    className="w-5 h-5 rounded-full"
                    src={user.image}
                    alt={user.label}
                  />
                  <span>{user.label}</span>
                </div>
              )}
            />
            <div className="flex gap-2">
              <button
                className="bg-red-500 w-full py-1 rounded-lg text-white"
                onClick={() => {
                  setIsOpen(false);
                  setIsEdit(false);
                  reset();
                }}
              >
                {t("common:cancel")}
              </button>
              <button
                disabled={isSubmiting}
                className="bg-azul-400 w-full py-1 rounded-lg text-white disabled:bg-azul-300"
              >
                {isEdit ? t("common:edit") : t("common:add")}
              </button>
            </div>
          </form>
        </ModalGeneric>
      )}
    </div>
  );
}
